"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelProgressBar = props => {
  const {
    backgroundSaturation = 100,
    barBackground = 'Light',
    className = '',
    classProgressBar = '',
    color = 'Primary',
    colorGoal = 'Green',
    fixedStep = [],
    goalValue = null,
    large = false,
    progressValue = 0,
    rounded = false,
    saturation = 400,
    saturationGoal = 400,
    showGoalValue = false,
    showInitialStatus = false,
    showInitialStatusColor = 'blueColor',
    showInitialStatusSatCol = 700,
    showInitialStatusTxt = null,
    showValue = false,
    small = false,
    xlarge = false
  } = props;
  const bgClass = barBackground ? `${barBackground.charAt(0).toUpperCase()}${barBackground.slice(1)}` : '';
  const classBackground = barBackground ? `bg${bgClass}${backgroundSaturation > 50 ? backgroundSaturation : ''}` : '';
  const colorClass = color ? `${color.charAt(0).toUpperCase()}${color.slice(1)}` : '';
  const colorInitialClass = showInitialStatusColor ? `${showInitialStatusColor.charAt(0).toUpperCase()}${showInitialStatusColor.slice(1)}` : '';
  const colorInitialClassSat = color ? `${colorInitialClass}${showInitialStatusSatCol > 50 ? showInitialStatusSatCol : ''}` : '';
  const classColor = color ? `bg${colorClass}${saturation > 50 ? saturation : ''}` : '';
  const txtClassColor = color ? `txt${colorClass}${saturation > 50 ? saturation : ''}` : '';
  const colorClassGoal = colorGoal ? `${colorGoal.charAt(0).toUpperCase()}${colorGoal.slice(1)}` : '';
  const classColorGoal = colorGoal ? `bg${colorClassGoal}${saturationGoal > 50 ? saturationGoal : ''}` : '';
  const classRounded = rounded ? 'brdRadius' : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "progressBar",
    className: `w-perc-100 ${classProgressBar}`,
    style: {
      height: `${xlarge ? '8px' : ''} ${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${classBackground} ov-h ${classRounded} pos-r`,
    style: {
      height: `${xlarge ? '8px' : ''} ${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  }, !progressValue && showInitialStatus ? (/*#__PURE__*/_react.default.createElement("span", {
    className: `activeProgBar dis-b ${className} bg${colorInitialClassSat} ${classRounded}`,
    style: {
      width: '10%',
      height: `${xlarge ? '8px' : ''} ${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  })) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, progressValue && (/*#__PURE__*/_react.default.createElement("span", {
    className: `activeProgBar dis-b ${className} ${classColor} ${classRounded}`,
    style: {
      width: `${progressValue}%`,
      height: `${xlarge ? '8px' : ''} ${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  })))), goalValue && (/*#__PURE__*/_react.default.createElement("span", {
    className: `goalProgBar pos-r dis-b ${className} ${classColorGoal} ${classRounded}`,
    style: {
      width: `${goalValue}%`,
      height: `${xlarge ? '8px' : ''} ${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  }))), showInitialStatusTxt && !progressValue && showInitialStatus && (/*#__PURE__*/_react.default.createElement("span", {
    className: `initStatus fsize-200 ff-mono txt${colorInitialClassSat}`
  }, showInitialStatusTxt)), showValue && progressValue && (/*#__PURE__*/_react.default.createElement("span", {
    className: `progressVal ff-mono ${txtClassColor} fweight-600 fsize-200`,
    style: {
      left: `${progressValue}%`
    }
  }, progressValue, "%")), showGoalValue && goalValue && (/*#__PURE__*/_react.default.createElement("span", {
    className: `goalValue txtGreen400 fsize-200 ff-mono ${txtClassColor}`,
    style: {
      left: `${goalValue}%`
    }
  }, goalValue, "%")), fixedStep && fixedStep.map((step, i) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `stp_${i.toString()}`
  }, step.val && +step.val > 0 && (/*#__PURE__*/_react.default.createElement("span", {
    key: `stp_${i.toString()}`,
    className: `fixedStep ${step.className || ''} fsize-200`,
    style: {
      left: `${step.val}%`
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `${fixedStep.length > 1 && i === 0 ? 'alignLeft' : ''}`
  }, step.label)))))));
};
var _default = exports.default = BrixelProgressBar;